import React from "react";
import { APIProvider } from "@vis.gl/react-google-maps";
import styles from "./venue.module.css";
import ResponsiveMap from "./ResponsiveMap";

function Venue() {
  return (
    <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAP_API_KEY}>
      <section className={styles.venueContainer}>
        <div className={styles.venueAddress}>
          <p>Borneo Royale Hotel Tawau</p>
          <p>&#40;Grand Ballroom 6th Floor&#41;</p>
        </div>

        <ResponsiveMap />
      </section>{" "}
    </APIProvider>
  );
}

export default Venue;
